import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgForwardiOs({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.588 12l-8.295-8.293a1 1 0 111.414-1.414l9.002 9a.997.997 0 010 1.414l-9.002 9a1 1 0 11-1.414-1.414L19.588 12z"
        fill={color}
      />
    </svg>
  )
}

export default SvgForwardiOs
